module.exports = __webpack_public_path__ + "static/media/LogoRectangle.730e7571.png";